import Result from "slotworks/model/gameplay/records/results/result";

export default class WheelBonusResult extends Result {
    public total: number;
    public remain: number;
}